<script setup>
import VideoTextItem from '@/components/contents/_items/VideoTextItem.vue'

const props = defineProps({
    title: String,
    content: Array,
})

</script>

<template>
    <section class="video-text-section">
            <h2 v-if="props.title" class="video-text-section__title">{{ props.title }} </h2>
            <VideoTextItem
                v-for="(item, index) in props.content"
                :class="{
                    'reverse': index % 2 === 1,
                    'first': index === 0,
                }"
                :key="index"
                :title="item.title"
                :content="item.content"
                :video="item.video"
                :buttonLabel="item.buttonLabel"
                :buttonLink="item.buttonLink"
                class="video-text-section__content"
            />
    </section>

</template>

<style lang="scss" scoped>
.video-text-section {

    width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: 65px;
    position: relative;


    & .video-text-section__title{
        max-width: 875px;
        width: 100%;
    }
    

    &:before{
        height: 75vh;
        content: "";
        position: absolute;
        aspect-ratio: 16 / 10;
        background-image: url(/images/stars.webp);
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        z-index: -1;
        opacity: .5;
        width: 100%;
        left: -25px;
    }
}


// Responsive styles
@media screen and (min-width: 767px) {
    .video-text-section {
        gap: 200px;
        padding: 0 50px;

        &::before{
            top: 125px;
            left: -15px;
            width: 83vw;
            transform: translate(15%, -50%);

        }
    }
}
</style>